import { render, staticRenderFns } from "./PublicDisplayQuestionForm.vue?vue&type=template&id=06c8356d&scoped=true"
import script from "./PublicDisplayQuestionForm.vue?vue&type=script&lang=js"
export * from "./PublicDisplayQuestionForm.vue?vue&type=script&lang=js"
import style0 from "./PublicDisplayQuestionForm.vue?vue&type=style&index=0&id=06c8356d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c8356d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06c8356d')) {
      api.createRecord('06c8356d', component.options)
    } else {
      api.reload('06c8356d', component.options)
    }
    module.hot.accept("./PublicDisplayQuestionForm.vue?vue&type=template&id=06c8356d&scoped=true", function () {
      api.rerender('06c8356d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PublicDisplay/PublicDisplayQuestionForm.vue"
export default component.exports